export default __webpack_public_path__ + "static/media/Ballroll_00244.70e5f1df.png";